import * as yup from 'yup';

import {$isNG} from '../../../models/utils';

const optionalDate = yup
    .date()
    .transform((value, originalValue) => {
        if (originalValue === '' || originalValue === null || originalValue === undefined) {
            return null;
        }
        return value;
    })
    .nullable();

export const generalInfoSchema = yup.object().shape({
    periodFrom: optionalDate,
    periodTo: optionalDate.when('periodFrom', (periodFrom: any, schema: any) => {
        if (!periodFrom) {
            return schema;
        }

        return schema.required().min(periodFrom);
    }),
    taxPointDate: optionalDate,
    buyerReference: yup.string().required(),
    contractDocumentReference: yup.string(),
    purchaseOrderReference: yup.string(),
    salesOrderReference: yup.string(),
});

type ValidationContext = {
    IS_NG: boolean;
};

export const createValidationContext = (): ValidationContext => ({IS_NG: $isNG.getState()});

const resolveFieldSchema = (fieldSchema: any, context: ValidationContext) => {
    if (!fieldSchema) {
        return null;
    }

    if (typeof fieldSchema.resolve === 'function') {
        return fieldSchema.resolve({
            context,
        });
    }

    return fieldSchema;
};

const hasRequiredTest = (schema: any) => {
    if (!schema) {
        return false;
    }

    // eslint-disable-next-line no-underscore-dangle
    const exclusiveTests = schema.exclusiveTests ?? schema._exclusive;
    if (exclusiveTests?.required) {
        return true;
    }

    const tests = schema.tests ?? [];
    return tests.some((test: any) => test?.OPTIONS?.name === 'required');
};

export const createIsFieldRequired = (context: ValidationContext) => {
    const resolvedSchema = generalInfoSchema.resolve({context});

    return (name: string) => {
        const fieldSchema = resolvedSchema.fields[name as keyof typeof resolvedSchema.fields];
        const concreteSchema = resolveFieldSchema(fieldSchema, context);

        return hasRequiredTest(concreteSchema);
    };
};
